import styled from "styled-components"
import { HashLink } from "react-router-hash-link"
import colors from "../../utils/style/colors.tsx"

const ContainerBanner = styled.div`
    height: fit-content;
    margin-bottom: 10%;
    margin-top: 12%;
    position: relative;

    @media (max-width: 1020px) {
        display: none;
    }
`

const Banner = styled.div`
    position: relative;
    border: solid 5px black;
    border-radius: 15px;
    height: fit-content;
    background-color: ${colors.pink};
    transform: rotate(-2deg);

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 15px;
        background-color: ${colors.pink};
        z-index: -1;
        box-shadow: 11px 11px ${colors.black};
    }
`

const TextContainerInBanner = styled.div`
    margin: 2%;
`

const TextInBanner = styled.p`
    color: ${colors.white};
    font-family: "Archivo Black", sans-serif;
    font-weight: 900;
    margin: 0;
    text-align: center;
    text-shadow: 3px 3px ${colors.h1_red};
    -webkit-text-stroke-color: ${colors.h1_red};
    line-height: 1.2;

    font-size: 62px;
    -webkit-text-stroke-width: 2px;
    transform: rotate(2deg);

    &:last-child {
        padding-bottom: 2%;
    }


    @media (max-width: 1020px) {
        font-size: 24px;
        text-shadow: 2px 2px ${colors.h1_red};
        -webkit-text-stroke-width: 1px;
    }
`

const ButtonWrapper = styled.div`
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(2deg); 
    width: 430px;
    
    @media (max-width: 1020px) {
        width: 300px;
        left: 52%;
    }    
`

const Button = styled(HashLink)`
    padding: 10px 20px;
    border: solid 4px ${colors.black};
    border-radius: 20px;
    font-family: "Archivo Black", sans-serif;
    box-shadow: 3px 3px ${colors.black};
    cursor: pointer;
    position: relative;
    background-color: ${colors.dark_red};
    color: ${colors.white};
    text-shadow: 3px 3px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 1.5px;
    font-size: 25px;
    line-height: 1;
    top: 25px;
    text-decoration: none;
    transition: all ease 0.3s;
    display: flex;

    &:hover{
        background-color: ${colors.dark_red};
        transition: all ease 0.3s;
        transform: translate(-5px, -5px);
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 15px;
        background-color: ${colors.dark_red};
        z-index: -1;
        box-shadow: 11px 11px ${colors.black};
    }

    @media (max-width: 1020px) {
        padding: 7px 10px;
        font-size: 16px;
        top: 20px;
        -webkit-text-stroke-width: 1px;
        box-shadow: 9px 9px ${colors.black};
    }
`

const linkScroll = () => {
    window.scrollTo({
        behavior: "smooth",
    })
}

function BannerDevis() {
    const texte = "Alors ?"
    const texte2 = "Vous êtes intéressé ?"

    return (
        <ContainerBanner>
            <Banner>
                <TextContainerInBanner>
                    <TextInBanner>{texte}</TextInBanner>
                    <TextInBanner>{texte2}</TextInBanner>
                </TextContainerInBanner>

                <ButtonWrapper>
                    <Button onClick={linkScroll} smooth to="/#contact">
                        Demandez un devis gratuit !
                    </Button>
                </ButtonWrapper>
            </Banner>
        </ContainerBanner>
    )
}

export default BannerDevis
